/**
 * @file: Nvr.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: NVR配置管理
 */
import request from '@/utils/request'

/**
 * 从萤石云的nvr设备拉取摄像头
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function nvrCameraPull(data) {
  return request({
    type: 'device',
    url: 'nvr/camera/pull',
    method: 'post',
    data
  })
}

/**
 * 删除nvr
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function nvrDelete(data) {
  return request({
    type: 'device',
    url: 'nvr/delete',
    method: 'post',
    data
  })
}

/**
 * nvr列表获取
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function nvrListGet(data) {
  return request({
    type: 'device',
    url: 'nvr/list/get',
    method: 'post',
    data
  })
}

/**
 * 添加nvr(新)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function nvrNewAdd(data) {
  return request({
    type: 'device',
    url: 'nvr/new/add',
    method: 'post',
    data
  })
}

/**
 * nvr信息获取(新)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function nvrNewGet(data) {
  return request({
    type: 'device',
    url: 'nvr/new/get',
    method: 'post',
    data
  })
}

/**
 * 编辑nvr(新)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function nvrNewUpdate(data) {
  return request({
    type: 'device',
    url: 'nvr/new/update',
    method: 'post',
    data
  })
}

/**
 * nvrIP与食堂ID（供小方使用）（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function nvrNvrdeptListGet(data) {
  return request({
    type: 'device',
    url: 'nvr/nvrdept/list/get',
    method: 'post',
    data
  })
}

/**
 * nvr下拉列表获取
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function nvrOptionListGet(data) {
  return request({
    type: 'device',
    url: 'nvr/option/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Nvr.js